<template>
  <SupportPageCard
    page-class="work-temp-page self-service-embed-page"
    :title="pageTitle"
    :show-back="!hideBackBtn"
    @back="goBack"
  >
    <div class="self-service-embed-frame-wrap">
      <iframe
        v-if="iframeUrl"
        class="self-service-embed-frame"
        :src="iframeUrl"
        frameborder="0"
        allow="clipboard-read; clipboard-write"
        @load="onIframeLoad"
      ></iframe>
    </div>
  </SupportPageCard>
</template>

<script>
import { mapState } from 'vuex';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import globalConfig from '@utiles/globalConfig';
import { buildFixedSelfServiceLink } from '@utiles/officialSupport';

const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;

export default {
  name: 'SelfServiceEmbed',
  mixins: [iframeMessage],
  components: {
    SupportPageCard
  },
  data() {
    return {
      hideBackBtn
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      curLang: state => state.curLang,
      isIframe: state => state.isIframe
    }),
    smartType() {
      return (
        this.$route.query.type ||
        this.$route.query.smartType ||
        this.$route.query.key ||
        ''
      );
    },
    pageTitle() {
      return (
        this.$route.query.name ||
        this.languages.workHomeSelfService ||
        ''
      );
    },
    iframeUrl() {
      if (!this.smartType) {
        return '';
      }
      return buildFixedSelfServiceLink(this.smartType, {
        language: this.curLang
      });
    }
  },
  methods: {
    goBack() {
      if (this.isIframe) {
        this.postMessageToParent('goBack');
      } else if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workhome');
      } else {
        this.$router.go(-1);
      }
    },
    /**
     * 进页滚顶：本页有 iframe，仅设 #ssr-page 不够。
     * - 真实滚动常在 html/body（officialSupport.scss overflow:auto）
     * - iframe load/聚焦时浏览器会把父页滚到 iframe 可见区，需在 load 后再滚一次
     * 不改动 iframe 内部样式，只重置父页滚动位置。
     */
    scrollPageToTop() {
      const reset = () => {
        const ssrPage = document.getElementById('ssr-page');
        if (ssrPage) ssrPage.scrollTop = 0;
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
        window.scrollTo(0, 0);
        const cardBody = this.$el && this.$el.querySelector
          ? this.$el.querySelector('.support-page-card__body')
          : null;
        if (cardBody) cardBody.scrollTop = 0;
      };
      this.$nextTick(() => {
        reset();
        // 再一帧，避开布局/聚焦抢滚动
        requestAnimationFrame(reset);
      });
    },
    onIframeLoad() {
      this.scrollPageToTop();
    }
  },
  mounted() {
    this.scrollPageToTop();
  }
};
</script>

<style lang="scss">
/* 与 work-temp 卡片一致，body 区域拉满放 iframe */
.page-layout.support-page-card.self-service-embed-page {
  .support-page-card__card {
    min-height: calc(100vh - 16vw);
  }

  .support-page-card__body {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding: 0;
  }

  .self-service-embed-frame-wrap {
    flex: 1;
    width: 100%;
    min-height: 60vh;
    overflow: hidden;
    border-radius: 2vw;
  }

  .self-service-embed-frame {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 60vh;
    border: 0;
  }
}

@media screen and (orientation: landscape) {
  .page-layout.pc.support-page-card.self-service-embed-page {
    .support-page-card__card {
      min-height: 70vh;
    }

    .self-service-embed-frame-wrap,
    .self-service-embed-frame {
      min-height: 55vh;
    }
  }
}
</style>
